import React from 'react'
import { Link } from "react-router-dom";
import PressRelease from '../home/PressRelease';


const Services = () => {
    return (
        <>

            <section className="page-title" style={{ backgroundImage: 'url(assets/images/background/3.jpg)' }}>
                <div className="auto-container">
                    <h2>Our Services </h2>
                    <ul className="bread-crumb clearfix">
                        <li><Link to="/">Home</Link></li>
                        <li style={{ color: "green" }}>Our Services </li>
                    </ul>
                </div>
            </section>
            <PressRelease />

            <section className="department-one" style={{ overflow: "hidden", marginTop: "-130px", backgroundColor: "#f6f7fb" }}>
                <div className="auto-container">
                    <div className="sec-title centered">
                        <h2 className="sec-title_heading">Our Departments</h2>
                    </div>
                    <p style={{ marginTop: "-40px" }}>Your overall well-being is guaranteed by the services provided by our department. Satna Swastik Hospital takes pleasure in providing care in important medical specialties.</p>
                    <div className="row clearfix">
                        <div className="department-one_block-two col-lg-4 col-md-6 col-sm-12">
                            <div className="department-one_block-two_inner">
                                <div className="department-one_block-two_image">
                                    <Link to="/general-medicine"><img src="assets/images/resource/department-7.jpg" alt /></Link>
                                </div>
                                <div className="department-one_block-two_content">
                                    <span className="department-one_block-two_icon flaticon-liver" />
                                    <h5 className="department-one_block-two_heading mt-lg-4"><Link to="/general-medicine">General Medicine and Cardiac Care</Link></h5>
                                    <div className="department-one_block-two_text">The General Medicine Department serves as a cornerstone within healthcare institutions, providing comprehensive medical care to patients across a wide spectrum of ailments and conditions. </div>
                                    <Link className="department-one_block-two_more" to="/general-medicine">read more</Link>
                                </div>
                            </div>
                        </div>
                        <div className="department-one_block-two col-lg-4 col-md-6 col-sm-12">
                            <div className="department-one_block-two_inner">
                                <div className="department-one_block-two_image">
                                    <Link to="/general-surgery"><img src="assets/img/surgery.webp" alt /></Link>
                                </div>
                                <div className="department-one_block-two_content">
                                    <span className="department-one_block-two_icon flaticon-skin" />
                                    <h5 className="department-one_block-two_heading mt-lg-4"><Link to="/general-surgery"> General Surgery</Link></h5>
                                    <div className="department-one_block-two_text">This is the branch of medicine that treats diseases through surgical procedures on various organs of the body. It primarily involves surgery on the abdomen and related organs. </div>
                                    <br />
                                    <br />
                                    <br />
                                    <Link className="department-one_block-two_more mt-lg-4" to="/general-surgery">read more</Link>
                                </div>
                            </div>
                        </div>
                        <div className="department-one_block-two col-lg-4 col-md-6 col-sm-12">
                            <div className="department-one_block-two_inner">
                                <div className="department-one_block-two_image">
                                    <Link to="/orthopedic"><img src="assets/images/resource/department-11.jpg" alt /></Link>
                                </div>
                                <div className="department-one_block-two_content">
                                    <span className="department-one_block-two_icon flaticon-hematology" />
                                    <h5 className="department-one_block-two_heading mt-lg-4"><Link to="/orthopedic">Orthopaedics</Link></h5>
                                    <div className="department-one_block-two_text">This is the branch of medicine that deals with the diagnosis, treatment, and rehabilitation of diseases, injuries, and deformities of the bones, joints, muscles, ligaments, tendons, and spine. </div>
                                    <br />
                                    {/* <br /> */}
                                    <Link className="department-one_block-two_more mt-lg-5" to="/orthopedic">read more</Link>
                                </div>
                            </div>
                        </div>
                        <div className="department-one_block-two col-lg-4 col-md-6 col-sm-12">
                            <div className="department-one_block-two_inner">
                                <div className="department-one_block-two_image">
                                    <Link to="/neurosurgery"><img src="assets/img/Neurosurgery.webp" alt /></Link>
                                </div>
                                <div className="department-one_block-two_content">
                                    <span className="department-one_block-two_icon flaticon-stethoscope" />
                                    <h5 className="department-one_block-two_heading mt-lg-4"><Link to="/neurosurgery">Neurosurgery</Link></h5>
                                    <div className="department-one_block-two_text">Disorders affecting the nervous system, which includes the brain, spinal cord, and peripheral nerves, are the focus of neurosurgery, a medical specialty.</div>
                                    <br />
                                    <br />
                                    <br />
                                    <Link className="department-one_block-two_more mt-lg-3" to="/neurosurgery">read more</Link>
                                </div>
                            </div>
                        </div>
                        <div className="department-one_block-two col-lg-4 col-md-6 col-sm-12">
                            <div className="department-one_block-two_inner">
                                <div className="department-one_block-two_image">
                                    <Link to="/paediatrics"><img src="assets/img/Department of Pediatrics.webp" alt /></Link>
                                </div>
                                <div className="department-one_block-two_content">
                                    <span className="department-one_block-two_icon flaticon-heart" />
                                    <h5 className="department-one_block-two_heading mt-lg-4"><Link to="/paediatrics">Department of Pediatrics</Link></h5>
                                    <div className="department-one_block-two_text">The field of medicine known as pediatrics is dedicated to the prevention, diagnosis, treatment, and management of all health issues affecting young patients, ranging from newborns and children to teenagers.</div>
                                    <Link className="department-one_block-two_more" to="/paediatrics">read more</Link>
                                </div>
                            </div>
                        </div>
                        <div className="department-one_block-two col-lg-4 col-md-6 col-sm-12">
                            <div className="department-one_block-two_inner">
                                <div className="department-one_block-two_image">
                                    <Link to="/gynaecology"><img src="assets/img/Department of Gynecology and Obstetrics.webp" alt /></Link>
                                </div>
                                <div className="department-one_block-two_content">
                                    <span className="department-one_block-two_icon flaticon-orthopedics" />
                                    <h5 className="department-one_block-two_heading mt-lg-4"><Link to="/gynaecology">Department of Gynecology and Obstetrics</Link></h5>

                                    <div className="department-one_block-two_text">Satna Swastik Hospital gynaecology department is a comprehensive unit that provides all services for women's reproductive and gynecological requirements in a thorough, considerate, and committed manner. </div>
                                    <Link className="department-one_block-two_more mt-lg-4" to="/gynaecology">read more</Link>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>


        </>
    )
}

export default Services